<div class="flex w-full items-center justify-center">
  @if (qrData()) {
  <div #qrCodeElement>
    <qrcode
      [qrdata]="qrData()"
      [width]="width()"
      [margin]="margin()"
      [errorCorrectionLevel]="errorCorrectionLevel()"
      [imageSrc]="imageSrc()"
      [imageWidth]="imageWidth()"
      [imageHeight]="imageHeight()"
    >
    </qrcode>
  </div>
  }
</div>
